import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["link"];
  static values = { mode: String };

  inject(event) {
    const fetchOptions = {
      method: 'GET',
      mode: 'cors',
      cache: 'default'
    }

    const modalInsert = document.querySelector('#modalInsert')
    const modalTitle = document.querySelector('#modalTitle')
    const isHouseholds = this.modeValue === 'households'

    if (modalTitle) {
      modalTitle.textContent = isHouseholds ? 'Ménages concernés' : 'Adresses concernées'
    }

    fetch(this.linkTarget.href, fetchOptions)
      .then(response =>
        response.json()
      )
      .then(data => {
        modalInsert.innerHTML = ''
        data.forEach(entry => {
          let html
          if (isHouseholds) {
            html = `<tr><td><a href="/relocation_items/${entry.id}/edit">${entry.label}</a></td></tr>`
          } else {
            html = `<tr><td><a href="/projects/${entry.id}">${entry.full_address}(L: ${entry.project_lots_count}) (RL: ${entry.relocation_items_count})</a></td></tr>`
          }
          modalInsert.insertAdjacentHTML('beforeend', html)
        })
      })
  }
}
